module.exports = __webpack_public_path__ + "static/media/cup.88ac3a8e.webp";